/* =========================================================
   DEKOFAR PRODUCT SYSTEM V2
   GLOBAL INITIALIZER

   Beklenen yükleme sırası:

   1.  dekofar-v2-core.js
   2.  dekofar-v2-campaign.js
   3.  dekofar-v2-gallery.js
   4.  dekofar-v2-shipping.js
   5.  dekofar-v2-bank-transfer.js
   6.  dekofar-v2-recommendations.js

   PAINT:
   7.  dekofar-v2-paint-calculator.js
   8.  dekofar-v2-paint-color.js
   9.  dekofar-v2-paint-package.js

   SHOE:
   10. dekofar-v2-shoe.js

   STANDARD:
   11. dekofar-v2-standard-options.js

   SON:
   12. dekofar-v2-init.js

   Bu dosya her zaman en son yüklenmelidir.
========================================================= */

(function dekofarV2InitializerBootstrap(
  window,
  document
) {
  'use strict';


  /* =======================================================
     SAFE MODULE RUNNER
  ======================================================= */

  function runIfAvailable(
    functionName,
    scope
  ) {

    const initializer =
      window[functionName];


    if (
      typeof initializer !==
      'function'
    ) {

      return false;
    }


    try {

      initializer(
        scope || document
      );


      return true;

    } catch (error) {

      console.error(
        `Dekofar V2 modülü başlatılamadı: ${functionName}`,
        error
      );


      return false;
    }

  }



  /* =======================================================
     INITIALIZE ALL MODULES
  ======================================================= */

  function initializeAll(scope) {

    const root =
      scope &&
      typeof scope.querySelectorAll ===
        'function'
        ? scope
        : document;



    /* =====================================================
       CORE VARIANT ENGINE

       MUTLAKA İLK ÇALIŞIR.
    ===================================================== */

    runIfAvailable(
      'initDekofarV2Products',
      root
    );



    /* =====================================================
       CAMPAIGN
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitCampaignCountdown',
      root
    );



    /* =====================================================
       GALLERY
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitProductGalleries',
      root
    );


    runIfAvailable(
      'dekofarV2InitVariantGallerySync',
      root
    );



    /* =====================================================
       SHIPPING / DELIVERY
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitShippingPromises',
      root
    );



    /* =====================================================
       BANK TRANSFER
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitBankTransfer',
      root
    );



    /* =====================================================
       PRODUCT RECOMMENDATIONS
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitProductRecommendations',
      root
    );



    /* =====================================================
       PAINT CALCULATOR
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitPaintCalculators',
      root
    );



    /* =====================================================
       PAINT COLOR SELECTOR
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitColorSelectors',
      root
    );



    /* =====================================================
       PAINT PACKAGE SELECTOR
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitPackageSelectors',
      root
    );



    /* =====================================================
       SHOE / AYAKKABI NUMARA SELECTOR

       Shoe ailesinde:
       - Numara kartlarını yönetir
       - Native Shopify select'i kontrol eder
       - Core varyant motoruyla senkron çalışır
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitShoeSelectors',
      root
    );



    /* =====================================================
       STANDARD OPTION CARDS

       Shoe ve Paint dışındaki ürünlerde:
       - Basamak
       - Boyut
       - Paket
       - Model
       vb. seçenekleri kart olarak yönetir.

       NOT:
       Ayakkabı numarası artık burada yönetilmez.
       Shoe kendi özel modülünü kullanır.
    ===================================================== */

    runIfAvailable(
      'dekofarV2InitStandardOptions',
      root
    );

    /* Stokta hiç bulunmayan renk / model / numaraları gizle. */
    runIfAvailable(
      'dekofarV2UpdateStockVisibility',
      root
    );

  }



  /* =======================================================
     PUBLIC API
  ======================================================= */

  window.dekofarV2InitializeAll =
    initializeAll;



  /* =======================================================
     INITIAL PAGE BOOT
  ======================================================= */

  function bootDocument() {

    initializeAll(
      document
    );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    if (
      !window.__dekofarV2DomReadyBound
    ) {

      window.__dekofarV2DomReadyBound =
        true;


      document.addEventListener(
        'DOMContentLoaded',
        bootDocument,
        {
          once: true
        }
      );

    }

  } else {

    bootDocument();

  }



  /* =======================================================
     SHOPIFY THEME EDITOR

     Tema düzenleyicisinde section yeniden yüklendiğinde
     ilgili bölümde bütün modüller yeniden kontrol edilir.

     Modüllerin kendi initialized flag'leri olduğu için
     duplicate listener oluşmaz.
  ======================================================= */

  if (
    !window.__dekofarV2SectionLoadBound
  ) {

    window.__dekofarV2SectionLoadBound =
      true;


    document.addEventListener(
      'shopify:section:load',
      (event) => {


        const sectionRoot =
          event &&
          event.target
            ? event.target
            : document;


        initializeAll(
          sectionRoot
        );

      }
    );

  }


})(
  window,
  document
);